import React, { useEffect, useState } from 'react'
//import images from '../images'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'
import AudioFileIcon from '@mui/icons-material/AudioFile'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
function SmartTile(props) {
  const {
    controlID,
    smartTileData,
    topTileFlex,
    bottomTileFlex,
    topTileSource,
    bottomTileSource,
    topTileType,
    bottomTileType,
    defaultValue,
    onValueSelect,
    onStopPress,
    playing,
    isPractice,
    completed,
    correctAnswerExplanation,
    incorrectAnswerExplanation,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    FillColor,
    FontColor,
    screenMode,
    isActive,
    reselectedTile,
    isEmptyTileVisible,
    isAudioPlaying
  } = props

  const [topTilePercentage, setTopTilePercentage] = useState(0)
  const [bottomTilePercentage, setBottomTilePercentage] = useState(0)
  const [isTileplaying, setIsTilePlaying] = useState(false)
  const [audio, setAudio] = useState(undefined)

  useEffect(() => {
    let sumOfFlex = topTileFlex + bottomTileFlex
    let topPer = parseFloat((topTileFlex / sumOfFlex) * 100)
    let bottomPer = parseFloat((bottomTileFlex / sumOfFlex) * 100)
    setTopTilePercentage(topPer + '%')
    setBottomTilePercentage(bottomPer + '%')
  }, [topTileFlex, bottomTileFlex])

  useEffect(() => {
    if (playing) {
      stopAudio()
    }
  }, [playing])

  function stopAudio() {
    if (audio) {
      audio.pause()
      audio.currentTime = 0
      setIsTilePlaying(false)
    }
  }

  function allowDrop(ev) {
    ev.preventDefault()
  }

  const renderTopTile = () => {
    if (topTileType === 'text') {
      return (
        <p
          className='tileElement'
          style={{
            fontStyle:
              smartTileData.Italic && smartTileData.Italic
                ? 'italic'
                : 'normal',
            fontWeight:
              smartTileData.Bold && smartTileData.Bold ? 'bold' : 'normal',
            fontSize:
              smartTileData.FontSize && smartTileData.FontSize === 'SMALL'
                ? SMALL_DESKTOP
                : smartTileData.FontSize === 'LARGE'
                ? LARGE_DESKTOP
                : MEDIUM_DESKTOP,
            textAlign: 'center'
          }}
        >
          {isVerifyMode ? topTileSource : defaultValue}
        </p>
      )
    } else if (topTileType === 'image') {
      return (defaultValue === null || defaultValue === '') &&
        !isVerifyMode ? undefined : isVerifyMode ? (
        <img
          src={topTileSource}
          alt='image'
          className='tileElement'
          style={{ objectFit: 'contain' }}
          draggable='false'
        />
      ) : (
        <img
          src={defaultValue}
          alt='image'
          className='tileElement'
          style={{ objectFit: 'contain' }}
          draggable='false'
        />
      )
    } else if (topTileType === 'ink') {
      return (defaultValue === null || defaultValue === '') &&
        !isVerifyMode ? undefined : isVerifyMode ? (
        <img
          src={topTileSource}
          alt='image'
          className='tileElement'
          style={{ objectFit: 'contain' }}
          draggable='false'
        />
      ) : (
        <img
          src={defaultValue}
          alt='image'
          className='tileElement'
          style={{ objectFit: 'contain' }}
          draggable='false'
        />
      )
    } else if (topTileType === 'audio') {
      if (defaultValue) {
        return (
          <span className='tileElement'>
            <AudioFileIcon
              style={{ width: '50px', height: '50px', color: FontColor }}
            />
          </span>
        )
      }
      return null
    } else if (topTileType === 'inktotext') {
      return (defaultValue === null || defaultValue === '') &&
        !isVerifyMode ? undefined : isVerifyMode ? (
        <span
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <InlineMath>{topTileSource}</InlineMath>
        </span>
      ) : (
        <span
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <InlineMath>{defaultValue}</InlineMath>
        </span>
      )
    }
  }
  const renderBottomTile = () => {
    if (bottomTileType === 'text') {
      return (
        <p
          className='tileElement'
          style={{
            fontStyle:
              smartTileData.Italic && smartTileData.Italic
                ? 'italic'
                : 'normal',
            fontWeight:
              smartTileData.Bold && smartTileData.Bold ? 'bold' : 'normal',
            fontSize:
              smartTileData.FontSize && smartTileData.FontSize === 'SMALL'
                ? SMALL_DESKTOP
                : smartTileData.FontSize === 'LARGE'
                ? LARGE_DESKTOP
                : MEDIUM_DESKTOP,
            textAlign: 'center'
          }}
        >
          {bottomTileSource}
        </p>
      )
    } else if (bottomTileType === 'inktotext') {
      return (
        <span
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          draggable='false'
        >
          <InlineMath>{bottomTileSource}</InlineMath>
        </span>
      )
    } else {
      return (
        <img
          src={bottomTileSource}
          alt='image'
          className='tileElement'
          draggable='false'
          style={{ objectFit: 'contain' }}
        />
      )
    }
  }

  return (
    <div
      className='column-1'
      style={{
        borderStyle: isVerifyMode ? 'solid' : 'none',
        width: screenMode === 'phone' ? '100px' : undefined,
        zIndex: 7
      }}
      draggable='false'
      // onDrop={(event) => {
      //   // handleDroppedItems(index, dragItem)
      //   if (completed === 0 && isActive) {
      //     onValueSelect()
      //   }
      // }}
      // onDragOver={(event) => allowDrop(event)}
    >
      <div
        className={
          isEmptyTileVisible && (defaultValue === null || defaultValue === '')
            ? 'column-tile-item-cont purple-border purple-shadow'
            : reselectedTile && reselectedTile.ControlID === controlID
            ? 'column-tile-item-cont selected-border'
            : isPractice || completed === 1 || !isActive
            ? defaultValue === null || defaultValue === ''
              ? completed === 1 || !isActive
                ? 'column-tile-item-cont wrong-border'
                : 'column-tile-item-cont default-border-2'
              : topTileSource === defaultValue
              ? 'column-tile-item-cont right-border'
              : 'column-tile-item-cont wrong-border'
            : 'column-tile-item-cont default-border-2'
        }
      >
        <div
          style={{
            height: topTilePercentage,
            backgroundColor: FillColor,
            position: 'relative',
            borderBottom: '2px solid #EAEAEA',
            zIndex: 6,
            borderRadius: '8px 8px 0px 0px'
          }}
          onClick={() => {
            if (explanationClick) {
              if (topTileSource === defaultValue) {
                onExplanationVisible(true, correctAnswerExplanation)
              } else {
                onExplanationVisible(false, incorrectAnswerExplanation)
              }
            } else {
              if (completed === 0 && isActive && !isAudioPlaying) {
                onValueSelect()
              }
            }
          }}
        >
          {renderTopTile()}
        </div>
        <div
          style={{
            height: bottomTilePercentage,
            backgroundColor: FillColor,
            position: 'relative',
            zIndex: 6,
            borderRadius: '0px 0px 8px 8px'
          }}
          onClick={() => {
            if (explanationClick) {
              if (topTileSource === defaultValue) {
                onExplanationVisible(true, correctAnswerExplanation)
              } else {
                onExplanationVisible(false, incorrectAnswerExplanation)
              }
            } else {
              if (completed === 0 && isActive && !isAudioPlaying) {
                onValueSelect()
              }
            }
          }}
        >
          {renderBottomTile()}
        </div>
      </div>
    </div>
  )
}

export { SmartTile }
